import { HTTP_CP_GetInbox_Response_InboxMessage } from '@api-new/reportingservice';
import { Dictionary, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { INBOX_FILTER } from '@shared/store/inbox/constants/inbox-filter';
import {
  getInbox,
  getInboxFailure,
  getInboxSuccess,
  markAllInboxMessagesAsReadFailure,
  markAllInboxMessagesAsReadSuccess,
  markInboxMessageAsReadFailure,
  markInboxMessageAsReadSuccess,
  setInboxFilter,
} from '@shared/store/inbox/inbox.actions';
import { InboxState } from '@shared/store/inbox/inbox.state';
import { InboxFilterModel } from '@shared/store/inbox/models/inbox-filter.model';

export const getInboxMessageById = (inboxMessage: Pick<HTTP_CP_GetInbox_Response_InboxMessage, 'activityLog'>): string =>
  inboxMessage.activityLog.id;

export const inboxAdapter: EntityAdapter<HTTP_CP_GetInbox_Response_InboxMessage> =
  createEntityAdapter<HTTP_CP_GetInbox_Response_InboxMessage>({
    selectId: getInboxMessageById,
  });

export const inboxInitialState: InboxState = inboxAdapter.getInitialState({
  loading: true,
  errors: null,
  unreadCount: 0,
  filter: null,
});

const reducer = createReducer(
  inboxInitialState,
  on(getInbox, (state) => ({ ...state, loading: true })),

  on(getInboxSuccess, (state, { response: { inboxMessages, unreadCount } }) =>
    inboxAdapter.addMany(inboxMessages ? inboxMessages : [], {
      ...state,
      loading: false,
      errors: null,
      unreadCount,
    }),
  ),

  on(markInboxMessageAsReadSuccess, (state, { message }) =>
    inboxAdapter.setOne(
      {
        activityLog: message.activityLog,
        isRead: true,
      },
      { ...state, unreadCount: state.unreadCount - 1 },
    ),
  ),

  on(markAllInboxMessagesAsReadSuccess, (state) =>
    inboxAdapter.map((entity) => ({ ...entity, isRead: isMessageRead(entity, state.filter) }), {
      ...state,
      unreadCount: getUnreadCount(state.entities, state.filter),
    }),
  ),

  on(setInboxFilter, (state, { filter }) => ({ ...state, filter })),

  on(getInboxFailure, markInboxMessageAsReadFailure, markAllInboxMessagesAsReadFailure, (state, { error }) => ({
    ...state,
    loading: false,
    errors: error,
  })),
);

export const inboxReducer = (state: InboxState = inboxInitialState, action: Action): InboxState => {
  return reducer(state, action);
};

const isMessageRead = (entity: HTTP_CP_GetInbox_Response_InboxMessage, filter: InboxFilterModel): boolean => {
  if (filter == null) return true;
  return INBOX_FILTER[filter].includes(entity.activityLog.entityType) ? true : entity.isRead;
};

const getUnreadCount = (entities: Dictionary<HTTP_CP_GetInbox_Response_InboxMessage>, filter: InboxFilterModel): number => {
  return Object.values(entities).filter((entity) => !isMessageRead(entity, filter)).length;
};
